<template>
  <div class="vertical-center">
    <p @click="popupActive=true">{{value}}</p>

    <vs-popup class="holamundo"  title="Setup Config" :active.sync="popupActive">
      <p>{{value}}</p>
    </vs-popup>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: 'DeviceRequestPopUp',
    data() {
      return {
        value: '',
        popupActive:false,
      }
    },
    methods: {
      
    },
    mounted() {
      if (this.params.value) {
        this.value = this.params.value
      }
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .width-100 {
    width: 100%;
  }
</style>

